export default {
  animationDuration: 200,
};
